/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Ask_Questions_Label_Question_SingularInputs */

const es_components_ask_questions_label_question_singular = /** @type {(inputs: Components_Ask_Questions_Label_Question_SingularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pregunta`)
};

const en_components_ask_questions_label_question_singular = /** @type {(inputs: Components_Ask_Questions_Label_Question_SingularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`question`)
};

/**
* | output |
* | --- |
* | "question" |
*
* @param {Components_Ask_Questions_Label_Question_SingularInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ask_questions_label_question_singular = /** @type {((inputs?: Components_Ask_Questions_Label_Question_SingularInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_Questions_Label_Question_SingularInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ask_questions_label_question_singular(inputs)
	return en_components_ask_questions_label_question_singular(inputs)
});
export { components_ask_questions_label_question_singular as "components.ask_questions.label.question_singular" }